<template>
  <el-dialog
    :title="'维护供应商'"
    :close-on-click-modal="false"
    class="abow_dialog"
    width="50%"
    :visible.sync="visible">
    <el-form  size="mini" :model="dataForm" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="110px" class="user-info-dialog-form">
      <el-row :gutter="40">
        <el-col :span="12">
          <el-form-item label="供应商代码" prop="venderCode">
            <el-input v-model="dataForm.venderCode"  placeholder="供应商代码" :disabled= true></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="供应商名称" prop="venderName">
            <el-input v-model="dataForm.venderName" placeholder="供应商名称" :disabled=true></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="40">
        <el-col :span="12">
          <el-form-item label="付款条件" prop="sapPayCondition">
            <el-select clearable v-model="dataForm.sapPayCondition" placeholder="请选择" style="width: 260px">
                <el-option
                v-for="item in sapPayConditionList"
                :key="item.sapPayCondition"
                :label="item.sapPayConditionDesc"
                :value="item.sapPayCondition">
                </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="付款方式" prop="sapZwels">
              <el-input v-model="dataForm.sapZwels" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

    </el-form>
    <el-row>
      <el-col style="text-align: right;">
        <el-button size="mini" @click="visible = false">取消</el-button>
        <el-button :loading="dataFormSubmitLoading" type="primary" size="mini" @click="dataFormSubmit()">确定</el-button>
      </el-col>
    </el-row>

    <el-dialog
          title="提示"
          :visible.sync="fileDialogVisible"
          width="60%"
          :modal="false"
          >
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="fileDialogVisible = false">关 闭</el-button>
          </span>
        </el-dialog>
  </el-dialog>
</template>

<script>
  import {selectSupplierById,frozenThaw,mainTain} from '@/controller/supplier'
  // import { fetchPayConditionList } from '@/controller/systemData'
  import { getPayConditionList } from '@/controller/systemData'
  
  export default {
    data () {
      
      return {
        fileDialogVisible:false,
        dataFormSubmitLoading:false,
        visible: false,
        FILE_BIZ_TYPE:5,
        FILE_SUB_TYPE:0,
        sapPayConditionList:[
            {
                sapPayCondition: 'V000',
                sapPayConditionDesc: "预付款",
            },
            {
                sapPayCondition: 'V001',
                sapPayConditionDesc: "立即付款",
            },
            {
                sapPayCondition: 'V030',
                sapPayConditionDesc: "30 天账期",
            },
            {
                sapPayCondition: 'V045',
                sapPayConditionDesc: "45 天账期",
            },
            {
                sapPayCondition: 'V060',
                sapPayConditionDesc: "60 天账期",
            },
            {
              sapPayCondition: 'V090',
              sapPayConditionDesc: "90 天账期",
            }],
        initValue: {
        },
        // 主要用于存储和页面显示相关的数据以及状态
        view: {
        },
        // 用于存储form 中的数据
        dataForm: {
          id: 0,
          isE:'',
          venderCode: '',
          venderName : '',
          remarks:'',
          sapZwels : 'BT',
          sapPayCondition : '',
          ftWorkFlowId:'',
          applyStatus:'',
        },
        files:[]
      }
    },


    methods: {
      init (row) {
        this.visible = true
        this.dataForm.id = row.id || 0
        this.dataForm.isE = row.isE
        this.dataForm.ftWorkFlowId = row.ftWorkFlowId
        this.dataForm.applyStatus = row.applyStatus

        if(row.isE === 0){
            this.FILE_SUB_TYPE = 3
        }
        if(row.isE === 1){
            this.FILE_SUB_TYPE = 4
        }

        this.$nextTick(() => {
            this.$refs['dataForm'].resetFields()
            // this.dataForm.tenantId = sessionStorage.getItem('tenantId')
            // this.dataForm.tenantName = sessionStorage.getItem('tenantName')
            //this.dataForm.userTypeList = []

        // 获取付款条件（账期）下拉列表
        getPayConditionList({
            'sapPayCondition': '',
            'sapPayConditionDesc': ''
        }).then(data => {
            if (data && data.code === '00') {
                // console.log(data)
                this.sapPayConditionList = data.body
            }
        }).catch((e) => {
            console.log(e)
        })


        selectSupplierById(
                  {id : this.dataForm.id}
           ).then(data => {
             if (data && data.code === '00') {
               this.dataForm = {...this.dataForm, ...data.body}
             }
           })
        
        })
      },
      

      handleRemove(file, fileList) {
        console.log(file, fileList);
      },
      handlePreview(file) {
        console.log(file);
      },

      // 表单提交
      dataFormSubmit () {
        this.$refs['dataForm'].validate((valid) => {
          if (valid) {
              var freezingThawFlg;
              if(this.dataForm.isE === 0){
                  freezingThawFlg = true;
              }
              if(this.dataForm.isE === 1){
                  freezingThawFlg = false;
              }
             
            let params = {
              'id': this.dataForm.id || undefined,
              'sapZwels': this.dataForm.sapZwels,
              'sapPayCondition': this.dataForm.sapPayCondition,
            }
            this.dataFormSubmitLoading = true
              mainTain(params
              ).then(data => {
                if (data && data.code === '00') {
                  this.$message({
                    message: '提交成功',
                    type: 'success',
                    duration: 1500,
                    onClose: () => {
                      this.visible = false
                      this.$emit('refreshDataList')
                      this.dataFormSubmitLoading = false
                    }
                  })
                } else {
                  this.dataFormSubmitLoading = false
                  this.$message.error(data.msg)
                }
              }).catch((e)=>{
                  this.dataFormSubmitLoading = false
              })
            
          }
        })
      },

    }
  }
</script>
<style lang="scss">
  .el-dialog__body{
    .user-info-dialog-form{
      width: 95%;
      .el-select{
        width: 222px;
      }
    }
  }
</style>